import * as React from "react";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

export default function BasicBreadcrumbs({ children }) {
  return (
    <div role="presentation" onClick={handleClick}>
      <Breadcrumbs sx={{ mb: 2 }} aria-label="breadcrumb">
        <Link underline="hover" color="primary" to="/vendors">
          vendors
        </Link>
        <Typography color="text.primary">
          {children || "vendor details"}
        </Typography>
      </Breadcrumbs>
    </div>
  );
}
